import React from 'react';
import LegalLayout from '../components/LegalLayout';

export default function RefundPage() {
  return (
    <LegalLayout title="Refund &amp; Cancellation Policy" lastUpdated="15 May 2026">

      <p><strong>Operator:</strong> Tambe Technologies (sole proprietorship of Raju Tambe, operating the CreatorKhata service), Bangalore, Karnataka, India.</p>

      <p>We want you to feel safe trying CreatorKhata. This policy explains how cancellations and refunds work.</p>

      <h2>1. 7-Day No-Questions-Asked Refund</h2>
      <p>If you upgrade to the Pro plan and find the Service is not a fit for you, you can request a full refund within <strong>7 calendar days</strong> of the payment date. No reason is required.</p>
      <p>The 7-day window applies to every payment — your first upgrade <em>and</em> each annual renewal. After the 7-day window for a given payment closes, that payment becomes non-refundable, but you can still cancel at any time to stop future renewals (see Section 5).</p>
      <p>We also honor refunds outside the 7-day window in cases of failed-service incidents — for example, extended downtime, broken features that blocked your work, or a Razorpay charging error.</p>

      <h2>2. How to Request a Refund</h2>
      <ol>
        <li>Email us at <a href="mailto:support@creatorkhata.com">support@creatorkhata.com</a> from the email address registered on your account.</li>
        <li>Include in your email:
          <ul>
            <li>The Razorpay payment ID (visible on the Razorpay receipt you received over email after payment)</li>
            <li>The plan and billing cycle you paid for (Pro Monthly or Pro Annual)</li>
            <li>The date of payment</li>
          </ul>
        </li>
        <li>We will acknowledge your request within 24 hours on business days.</li>
      </ol>

      <h2>3. Refund Processing</h2>
      <ul>
        <li>Approved refunds are initiated via Razorpay within <strong>2 business days</strong> of confirming eligibility.</li>
        <li>The refund is credited to your original payment method (the same card / UPI account / bank account you paid from).</li>
        <li>Banks typically take an additional <strong>5–10 business days</strong> to reflect the credit on your statement. This timeline is controlled by your bank, not by us.</li>
      </ul>

      <h2>4. What Happens to Your Data After a Refund</h2>
      <p>When a refund is processed, your account is reverted to the Free plan. Existing data (deals, content, ideas, invoices, etc.) remains accessible within Free-plan limits. You may continue using the Free tier or request full account deletion.</p>

      <h2>5. Cancellation</h2>
      <p>You can cancel your Pro subscription at any time, with one click, from your account settings — no email required. After cancellation:</p>
      <ul>
        <li>Your paid Pro access continues until the end of the period you have already paid for (the end of the current month if on the Monthly plan, the end of the current year if on the Annual plan).</li>
        <li>After that, your account automatically moves to the Free plan. All your data — deals, invoices, ideas, rate cards — stays exactly as it was, accessible within Free-plan limits.</li>
        <li>No further charges occur. Razorpay's auto-debit mandate is revoked at the moment you cancel.</li>
      </ul>
      <p>For annual subscribers, we email a renewal reminder seven (7) days before each annual renewal so you have time to cancel if you no longer wish to continue.</p>
      <p>Cancellation does not, by itself, trigger a refund. Refund eligibility for an already-completed payment is governed by Section 1 (the 7-day window).</p>

      <h2>6. Exceptions</h2>
      <p>Refunds may be denied in the following circumstances:</p>
      <ul>
        <li>The request is made more than 7 calendar days after the payment date;</li>
        <li>The account has been terminated due to violation of our <a href="/terms">Terms of Service</a>;</li>
        <li>The payment is part of an active chargeback initiated by you with your card-issuing bank (chargeback and refund cannot run in parallel — resolve the chargeback first).</li>
      </ul>

      <h2>7. Chargebacks</h2>
      <p>If you initiate a chargeback or payment dispute through your bank without first contacting us, your CreatorKhata account may be suspended pending resolution. Please email us first — we settle 99% of disputes faster and more cleanly than the card network does.</p>

      <h2>8. Contact</h2>
      <p>For any refund question, write to <a href="mailto:support@creatorkhata.com">support@creatorkhata.com</a>.</p>

    </LegalLayout>
  );
}
